import {Component, Input} from '@angular/core';
import {SettingsPageComponent} from "../../x-components/settings/settings-page/settings-page.component";
import {AppRoutes} from "../../enums/routes";
import {ActivatedRoute, Router} from "@angular/router";
import {GlobalAlertService} from "../../_services/global-alert.service";
import {PermissionService} from "../../_auth/permission.service";
import {SettingsInputElementModel} from "../../models/settings-input-element-model";
import {HttpPropertyChangeStatus} from "../../enums/http-property-change-status";
import {ObservableQueueElement} from "../../models/observable-queue-element";
import {AlertLevel} from "../../enums/alert-level";
import {LocationDto} from "../../models/location-dto";
import {LocationHttpService} from "../../http-requests/location-http.service";
import {CalculationType, CalculationTypeLabels, CalculationTypes} from "../../_models/_general/calculation-type";
import {Tuple} from "../../models/_generic/tuple";
import {SalaryModifier} from "../../_modules/location/_models/salary-modifier";
import {
  SettingsInputElementComponent
} from "../../x-components/settings/settings-input-element/settings-input-element.component";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-location-settings',
  templateUrl: '../../x-components/settings/settings-page/settings-page.component.html',
  imports: [
    CommonModule,
    SettingsInputElementComponent
  ],
  styleUrls: ['./location-settings.component.scss']
})
export class LocationSettingsComponent extends SettingsPageComponent {
  public redirectRoute: string = AppRoutes.Locations;
  public settingsInputElementModel: { [key: string]: SettingsInputElementModel } = {
    newLocationName: new SettingsInputElementModel(),
    newReceivesTip: new SettingsInputElementModel(),
    newOrderNumber: new SettingsInputElementModel(),
    newDefaultEmployeeCount: new SettingsInputElementModel(),
    newDefaultChangeAmount: new SettingsInputElementModel(),

    salary_separator: new SettingsInputElementModel(),
    salary_calculationType: new SettingsInputElementModel(),
    salary_value: new SettingsInputElementModel()
  };
  public model?: LocationDto;
  public timeoutClick: boolean = false;

  constructor(route: ActivatedRoute,
              PermissionService: PermissionService,
              public locationHttpService: LocationHttpService,
              router: Router,
              globalAlertService: GlobalAlertService) {
    super(route, PermissionService, router, globalAlertService);
    this.settingsInputElementModel.newLocationName.propertyTitle = "Name";
    this.settingsInputElementModel.newLocationName.requiredPermission = PermissionService.Inventory_Location_ChangeName()
    this.settingsInputElementModel.newLocationName.order = 1;

    this.settingsInputElementModel.newOrderNumber.propertyTitle = "Reihenfolge";
    this.settingsInputElementModel.newOrderNumber.requiredPermission = PermissionService.Inventory_Location_SetOrder()
    this.settingsInputElementModel.newOrderNumber.order = 2;
    this.settingsInputElementModel.newOrderNumber.inputType = "number";

    this.settingsInputElementModel.newDefaultChangeAmount.propertyTitle = "Wechselgeld";
    this.settingsInputElementModel.newDefaultChangeAmount.requiredPermission = PermissionService.Inventory_Location_SetValue();
    this.settingsInputElementModel.newDefaultChangeAmount.order = 3;
    this.settingsInputElementModel.newDefaultChangeAmount.inputType = "number";

    this.settingsInputElementModel.salary_separator.propertyTitle = "Lohneinstellungen";
    this.settingsInputElementModel.salary_separator.inputType = "separator";
    this.settingsInputElementModel.salary_separator.requiredPermission = (PermissionService.CheckPermission(PermissionService.Inventory_Location_SetTipShare()) ? PermissionService.Inventory_Location_SetTipShare() : PermissionService.Inventory_Location_SetSalaryModifier())
    this.settingsInputElementModel.salary_separator.order = 10;

    this.settingsInputElementModel.newReceivesTip.propertyTitle = "Anteil am TG";
    this.settingsInputElementModel.newReceivesTip.requiredPermission = PermissionService.Inventory_Location_SetTipShare()
    this.settingsInputElementModel.newReceivesTip.order = 11;
    this.settingsInputElementModel.newReceivesTip.inputType = "checkbox";

    this.settingsInputElementModel.newDefaultEmployeeCount.propertyTitle = "Anzahl Arbeitsplätze";
    this.settingsInputElementModel.newDefaultEmployeeCount.requiredPermission = PermissionService.Inventory_Location_SetDefaultEmployeeCount()
    this.settingsInputElementModel.newDefaultEmployeeCount.order = 3;
    this.settingsInputElementModel.newDefaultEmployeeCount.inputType = "number";

    this.settingsInputElementModel.salary_calculationType.propertyTitle = "Zuschlagsart";
    this.settingsInputElementModel.salary_calculationType.requiredPermission = PermissionService.Inventory_Location_SetSalaryModifier();
    this.settingsInputElementModel.salary_calculationType.order = 12;
    this.settingsInputElementModel.salary_calculationType.inputType = "dropdown";
    this.settingsInputElementModel.salary_calculationType.items = CalculationTypes.map((value) => {
      return new Tuple(parseInt(value[0]), CalculationTypeLabels[parseInt(value[0])]);
    })

    this.settingsInputElementModel.salary_value.propertyTitleFunction = () => this.settingsInputElementModel.salary_calculationType.changeableProperties.newPropertyValue === CalculationType.Percentage ? "Zuschlag (Faktor)" : "Zuschlag in €";
    this.settingsInputElementModel.salary_value.requiredPermission = PermissionService.Inventory_Location_SetSalaryModifier();
    this.settingsInputElementModel.salary_value.order = 13;
    this.settingsInputElementModel.salary_value.inputType = "number";

    this.deletePermission = PermissionService.CheckPermission(PermissionService.Inventory_Location_Delete());
  }

  deleteModel = () => {
    if (this.model === undefined || !this.deletePermission) return;
    this.locationHttpService.delete(this.model.id).subscribe(() => {
      this.globalAlertService.createAlertBannerModel("Verkaufspunkt gelöscht", "Verkaufspunkt wurde erfolgreich gelöscht", AlertLevel.success, 5000)
      this.globalAlertService.show();
    });
  };

  @Input() saveChanges: Function = () => {
    if (this.model === undefined) return;

    this.requiresChanges.push(this.saveName())
    this.requiresChanges.push(this.saveReceivesTip())
    this.requiresChanges.push(this.saveOrder())
    this.requiresChanges.push(this.saveDefaultEmployeeCount())
    this.requiresChanges.push(this.saveSalaryModifier())

    this.requiresChanges.push(this.saveValueProperty("DefaultChangeAmount", this.settingsInputElementModel.newDefaultChangeAmount, (id, property, newValue) => {
      return this.locationHttpService.setValue(id, property, newValue);
    }));

    if (!this.changeRequestRequired()) return;

    this.executeQueueWrapper();
  }

  @Input() loadInputModel: Function = (id: string) => {
    this.locationHttpService.get(id).subscribe((model: LocationDto) => {
      this.model = model;
      this.settingsInputElementModel.newLocationName.originalPropertyValue = this.settingsInputElementModel.newLocationName.changeableProperties.newPropertyValue = model.name;
      this.settingsInputElementModel.newReceivesTip.originalPropertyValue = this.settingsInputElementModel.newReceivesTip.changeableProperties.newPropertyValue = model.receivesTips;
      this.settingsInputElementModel.newOrderNumber.originalPropertyValue = this.settingsInputElementModel.newOrderNumber.changeableProperties.newPropertyValue = model.order;
      this.settingsInputElementModel.newDefaultEmployeeCount.originalPropertyValue = this.settingsInputElementModel.newDefaultEmployeeCount.changeableProperties.newPropertyValue = model.defaultEmployeeCount;
      setTimeout(() => {
        this.settingsInputElementModel.salary_calculationType.originalPropertyValue = this.settingsInputElementModel.salary_calculationType.changeableProperties.newPropertyValue = model.salaryModifier?.calculationType ?? CalculationType.AbsolutePerHour;
      })
      this.settingsInputElementModel.salary_value.originalPropertyValue = this.settingsInputElementModel.salary_value.changeableProperties.newPropertyValue = model.salaryModifier?.value ?? 0;
      this.settingsInputElementModel.newDefaultChangeAmount.originalPropertyValue = this.settingsInputElementModel.newDefaultChangeAmount.changeableProperties.newPropertyValue = model.defaultChangeAmount;
    });
  }

  saveName(): HttpPropertyChangeStatus {
    if (this.model === undefined) return HttpPropertyChangeStatus.NotChanged;
    if (this.settingsInputElementModel.newLocationName.changeableProperties.newPropertyValue === undefined) return HttpPropertyChangeStatus.NotChanged;
    if (this.settingsInputElementModel.newLocationName.changeableProperties.newPropertyValue === this.settingsInputElementModel.newLocationName.originalPropertyValue) return HttpPropertyChangeStatus.NotChanged;


    let observableQueueElement: ObservableQueueElement = new ObservableQueueElement();
    observableQueueElement.observable = this.locationHttpService.changeName(this.model.id, this.settingsInputElementModel.newLocationName.changeableProperties.newPropertyValue);
    observableQueueElement.callback = (model: LocationDto) => {
      this.model = model;
      this.settingsInputElementModel.newLocationName.originalPropertyValue = this.settingsInputElementModel.newLocationName.changeableProperties.newPropertyValue = model.name;
      observableQueueElement.successIndicator = true;
      this.updateElements();
    }
    observableQueueElement.callbackError = (error: any) => {
      this.globalAlertService.createAlertBannerModel("Fehler", "Fehler beim Speichern des Namens.", AlertLevel.error, 5000);
      this.globalAlertService.show();
      observableQueueElement.successIndicator = false;
    }

    this.observableQueue.push(observableQueueElement);

    return HttpPropertyChangeStatus.Changed;
  }

  saveSalaryModifier(): HttpPropertyChangeStatus {
    if (this.model === undefined) return HttpPropertyChangeStatus.NotChanged;
    if (
      this.settingsInputElementModel.salary_value.changeableProperties.newPropertyValue === undefined &&
      this.settingsInputElementModel.salary_calculationType.changeableProperties.newPropertyValue === undefined
    ) return HttpPropertyChangeStatus.NotChanged;
    if (
      this.settingsInputElementModel.salary_value.changeableProperties.newPropertyValue === this.settingsInputElementModel.salary_value.originalPropertyValue &&
      this.settingsInputElementModel.salary_calculationType.changeableProperties.newPropertyValue === this.settingsInputElementModel.salary_calculationType.originalPropertyValue
    ) return HttpPropertyChangeStatus.NotChanged;


    let observableQueueElement: ObservableQueueElement = new ObservableQueueElement();
    let model = new SalaryModifier();
    model.calculationType = this.settingsInputElementModel.salary_calculationType.changeableProperties.newPropertyValue;
    model.value = this.settingsInputElementModel.salary_value.changeableProperties.newPropertyValue;

    observableQueueElement.observable = this.locationHttpService.setSalaryModifier(this.model.id, model);
    observableQueueElement.callback = (model: LocationDto) => {
      this.model = model;
      this.settingsInputElementModel.salary_value.originalPropertyValue = this.settingsInputElementModel.salary_value.changeableProperties.newPropertyValue = model.salaryModifier?.value ?? 0;
      this.settingsInputElementModel.salary_calculationType.originalPropertyValue = this.settingsInputElementModel.salary_calculationType.changeableProperties.newPropertyValue = model.salaryModifier?.calculationType ?? CalculationType.AbsolutePerHour;
      observableQueueElement.successIndicator = true;
      this.updateElements();
    }
    observableQueueElement.callbackError = (error: any) => {
      this.globalAlertService.createAndShow("Fehler", "Fehler beim Speichern der Lohn-Zuschläge am Trinkgeld.", AlertLevel.error);
      observableQueueElement.successIndicator = false;
    }

    this.observableQueue.push(observableQueueElement);

    return HttpPropertyChangeStatus.Changed;
  }

  saveReceivesTip(): HttpPropertyChangeStatus {
    if (this.model === undefined) return HttpPropertyChangeStatus.NotChanged;
    if (this.settingsInputElementModel.newReceivesTip.changeableProperties.newPropertyValue === undefined) return HttpPropertyChangeStatus.NotChanged;
    if (this.settingsInputElementModel.newReceivesTip.changeableProperties.newPropertyValue === this.settingsInputElementModel.newReceivesTip.originalPropertyValue) return HttpPropertyChangeStatus.NotChanged;


    let observableQueueElement: ObservableQueueElement = new ObservableQueueElement();
    observableQueueElement.observable = this.locationHttpService.setTipShare(this.model.id, this.settingsInputElementModel.newReceivesTip.changeableProperties.newPropertyValue);
    observableQueueElement.callback = (model: LocationDto) => {
      this.model = model;
      this.settingsInputElementModel.newReceivesTip.originalPropertyValue = this.settingsInputElementModel.newReceivesTip.changeableProperties.newPropertyValue = model.receivesTips;
      observableQueueElement.successIndicator = true;
      this.updateElements();
    }
    observableQueueElement.callbackError = (error: any) => {
      this.globalAlertService.createAlertBannerModel("Fehler", "Fehler beim Speichern der Beteiligung am Trinkgeld.", AlertLevel.error, 5000);
      this.globalAlertService.show();
      observableQueueElement.successIndicator = false;
    }

    this.observableQueue.push(observableQueueElement);

    return HttpPropertyChangeStatus.Changed;
  }

  saveOrder(): HttpPropertyChangeStatus {
    if (this.model === undefined) return HttpPropertyChangeStatus.NotChanged;
    if (this.settingsInputElementModel.newOrderNumber.changeableProperties.newPropertyValue === undefined) return HttpPropertyChangeStatus.NotChanged;
    if (this.settingsInputElementModel.newOrderNumber.changeableProperties.newPropertyValue === this.settingsInputElementModel.newOrderNumber.originalPropertyValue) return HttpPropertyChangeStatus.NotChanged;


    let observableQueueElement: ObservableQueueElement = new ObservableQueueElement();
    observableQueueElement.observable = this.locationHttpService.setOrder(this.model.id, this.settingsInputElementModel.newOrderNumber.changeableProperties.newPropertyValue);
    observableQueueElement.callback = (model: LocationDto) => {
      this.model = model;
      this.settingsInputElementModel.newOrderNumber.originalPropertyValue = this.settingsInputElementModel.newOrderNumber.changeableProperties.newPropertyValue = model.order;
      observableQueueElement.successIndicator = true;
      this.updateElements();
    }
    observableQueueElement.callbackError = (error: any) => {
      this.globalAlertService.createAlertBannerModel("Fehler", "Fehler beim Speichern der Reihenfolge.", AlertLevel.error, 5000);
      this.globalAlertService.show();
      observableQueueElement.successIndicator = false;
    }

    this.observableQueue.push(observableQueueElement);

    return HttpPropertyChangeStatus.Changed;
  }


  saveDefaultEmployeeCount(): HttpPropertyChangeStatus {
    if (this.model === undefined) return HttpPropertyChangeStatus.NotChanged;
    if (this.settingsInputElementModel.newDefaultEmployeeCount.changeableProperties.newPropertyValue === undefined) return HttpPropertyChangeStatus.NotChanged;
    if (this.settingsInputElementModel.newDefaultEmployeeCount.changeableProperties.newPropertyValue === this.settingsInputElementModel.newDefaultEmployeeCount.originalPropertyValue) return HttpPropertyChangeStatus.NotChanged;


    let observableQueueElement: ObservableQueueElement = new ObservableQueueElement();
    observableQueueElement.observable = this.locationHttpService.setDefaultEmployeeCount(this.model.id, this.settingsInputElementModel.newDefaultEmployeeCount.changeableProperties.newPropertyValue);
    observableQueueElement.callback = (model: LocationDto) => {
      this.model = model;
      this.settingsInputElementModel.newDefaultEmployeeCount.originalPropertyValue = this.settingsInputElementModel.newDefaultEmployeeCount.changeableProperties.newPropertyValue = model.defaultEmployeeCount;
      observableQueueElement.successIndicator = true;
      this.updateElements();
    }
    observableQueueElement.callbackError = (error: any) => {
      this.globalAlertService.createAlertBannerModel("Fehler", "Fehler beim Speichern der Mitarbeiteranzahl.", AlertLevel.error, 5000);
      this.globalAlertService.show();
      observableQueueElement.successIndicator = false;
    }

    this.observableQueue.push(observableQueueElement);

    return HttpPropertyChangeStatus.Changed;
  }
}
